const createType = type => `NOTIFICATION/${type}`;

export const NOTIFICATION_DISMISS = createType('DISMISS');
export const NOTIFICATION_FETCH = createType('FETCH');
export const NOTIFICATION_READ = createType('READ');
export const NOTIFICATION_PUSH = createType('PUSH');
